export const useNormalizeCallLocationName = () => {
  // PUT /call/<callId>/callee-phone-number returns misspelled 'EMERGENCY' value for the 'HearingConnection Location' and 'CalleeConnection Location' fields.
  const normalizeLocationName = (value: string): string =>
    value === 'EMERGNCY' ? 'EMERGENCY' : value;

  return { normalizeLocationName };
};
